import React, { useEffect, useState, useContext } from "react";
// import Select from "react-select";
import { Select } from "antd"
import Switch from "./AndOrToggleSwtich";
import ToggleButton from "./ToggleAndOrSwitch";
import { PeFilterContext } from "../../Contexts/PeFilterContext";

const options = [
  { value: "revenue", label: "Revenue", moreThan: "", years: 2 },
  { value: "ebitda", label: "EBITDA", moreThan: "", years: 2 },
  { value: "net_profit", label: "Net profit", moreThan: "", years: 2 }
];
const MaxYears = [2, 3, 4, 5]

/**
 * The RatiosBasedFilter component is a JavaScript function that renders a filter component for
 * growth-based ratios in a user interface.
 * @returns The RatiosBasedFilter component is being returned.
 */
const RatiosBasedFilter = ({ open,
  accordionClick,
  customPathname,
  label = "Growth Based",
  GrowthYear,
  setGrowthYear,
  GrowthOptions,
  setGrowthOptions,
  IsCAGR,
  setIsCAGR,
  AndOr,
  setAndOr,
  isPopupOpen,
  setIsPopupOpen
}) => {
  const { refineSearchFilters } = useContext(PeFilterContext);


  /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
  `useEffect` hook is being used to update the state variables `growthYear`, `growthOptions`,
  `cagr`, and `andOr` based on the values stored in the `refineSearchFilters` object. */
  useEffect(() => {
    const growthYear = refineSearchFilters[customPathname]?.growthYear?.at(0)?.value;
    const growthOptions = refineSearchFilters[customPathname]?.growthPercentage?.map(option => option.value);
    const cagr = refineSearchFilters[customPathname]?.growthCAGR?.at(0)?.value;
    const andOr = refineSearchFilters[customPathname]?.growthOperator?.at(0)?.value ?? 'or'
    setGrowthYear(growthYear ?? "any")
    setGrowthOptions(growthOptions ?? []);
    setIsCAGR(cagr ?? false);
    setAndOr(andOr);
  }, [customPathname, refineSearchFilters, setAndOr, setGrowthOptions, setGrowthYear, setIsCAGR])


  //new event listeners
  /**
   * The function `onGrowthYearChange` sets the value of `growthYear` to the provided `value`.
   * @param value - The value parameter is the new value for the growth year.
   */
  const onGrowthYearChange = (value) => {
    // setGrowthYear(prev => prev === value ? null : value)
    setGrowthYear(value)
    // setGrowthOptions([])
  }

  /**
   * The function `onGrowthOptionChange` logs the selected growth options and sets the growth options
   * state.
   * @param e - The parameter "e" is an event object that represents the event that triggered the
   * change. It can be used to access information about the event, such as the target element that
   * triggered the change.
   * @param selectedGrowths - The `selectedGrowths` parameter is an array that contains the selected
   * growth options.
   */
  const onGrowthOptionChange = (e, selectedGrowths) => {
    console.log('onGrowthOptionChange', selectedGrowths);
    setGrowthOptions(selectedGrowths)
  }


  /**
   * The function `onOptionsYearChange` is used to update the growth options based on the selected
   * year.
   * @param index - The index parameter represents the index of the growth option in the growthOptions
   * array. It is used to identify which growth option needs to be updated.
   * @param optionKey - The `optionKey` parameter is a string that represents the key of the option
   * being changed. In this code snippet, it can have two possible values: "moreThan" or "years".
   * @param value - The `value` parameter in the `onOptionsYearChange` function represents the new
   * value that is being passed for a specific option. It could be a number, a string, or any other
   * valid data type depending on the context of the code.
   */
  const onOptionsYearChange = (index, optionKey, value) => {

    setGrowthOptions(prev => {
      let temp = [...prev];
      if (optionKey === "moreThan") {
        const validNumber = new RegExp(/^\d*\.?\d*$/);
        let processedValue = "";
        if (validNumber.test(value)) {
          processedValue = value;
        } else {
          processedValue = temp[index].moreThan;
        }
        temp[index].moreThan = processedValue
      } else if (optionKey === "years") {
        temp[index].years = value
      }
      console.log('selectedGrowths', index, optionKey, value, temp);
      return temp;
    })
  }

  const getSelectedCount = () => {
    return GrowthOptions?.filter(option => option.moreThan !== "").length || 0;
  };

  return (
    <div className="px-4 bg-white">
      <h3 className="text-lg font-semibold mb-4 text-[#333333] flex items-center justify-between">
        <span>{label}</span>
        {getSelectedCount() > 0 && (
          <span className="bg-[#BC8B20] text-white text-xs rounded-full px-2 py-1 min-w-[20px] text-center">
            {getSelectedCount()}
          </span>
        )}
      </h3>

      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <label className="font-semibold text-sm text-[#333333]">Year:</label>
            <div className="flex gap-3">
              <div className="flex items-center">
                <input
                  className="cursor-pointer mr-2"
                  value="all"
                  type="radio"
                  key="all"
                  id="growth-all"
                  checked={GrowthYear === "all"}
                  onChange={() => onGrowthYearChange('all')}
                />
                <label htmlFor="growth-all" className="text-sm cursor-pointer whitespace-nowrap">
                  All
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="radio"
                  className="cursor-pointer mr-2"
                  value="any"
                  key="any"
                  id="growth-any"
                  checked={GrowthYear === "any"}
                  onChange={() => onGrowthYearChange('any')}
                />
                <label htmlFor="growth-any" className="text-sm cursor-pointer whitespace-nowrap">
                  Any
                </label>
              </div>
            </div>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="cagr"
              key="cagr"
              className="cursor-pointer mr-2"
              checked={IsCAGR}
              onChange={() => setIsCAGR(prev => !prev)}
            />
            <label htmlFor="cagr" className="text-sm cursor-pointer whitespace-nowrap">
              CAGR
            </label>
          </div>
        </div>

        <div>
          <Select
            mode="multiple"
            showSearch
            options={options}
            optionFilterProp='label'
            value={GrowthOptions}
            onChange={onGrowthOptionChange}
            placeholder="Select growth metrics"
            style={{
              width: '100%',
              border: '1px solid #BC8B20',
              borderRadius: '4px',
              background: '#ffffff',
              maxHeight: '60px',
              overflowY: "auto"
            }}
            bordered={false}
          />
        </div>

        {GrowthOptions.length > 0 && (
          <div>
            <div className="grid grid-cols-3 gap-3 mb-3">
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333]">Fields</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center">More than(%)</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center"># of Yrs</label>
            </div>

            {GrowthOptions.map((option, i) => (
              <div key={option.value} className="grid grid-cols-3 gap-3 items-center mb-2">
                <div className="text-sm text-[#333333] font-sans_book_body">{option.label}</div>
                <div>
                  <input
                    className="border border-gray-300 rounded p-2 w-full text-sm"
                    type="text"
                    autoComplete="off"
                    max={100}
                    required
                    placeholder="Percentage"
                    value={option.moreThan}
                    onChange={(e) => onOptionsYearChange(i, 'moreThan', e.target.value)}
                  />
                </div>
                <div>
                  <select
                    value={option.years}
                    onChange={(e) => onOptionsYearChange(i, 'years', e.target.value)}
                    className="border border-gray-300 rounded focus:outline-none bg-[#FFFFFF] w-full p-2 text-sm"
                  >
                    {MaxYears.map((value, index) => (
                      <option key={index} value={value}>{value}</option>
                    ))}
                  </select>
                </div>
              </div>
            ))}

            <hr className="my-4" />

            <div>
              <ToggleButton
                value={AndOr === "or"}
                onLabel="AND"
                offLabel="OR"
                onToggle={(value) => setAndOr(value)}
                from="cfsRefineSearch"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default RatiosBasedFilter;

